import Vue from 'vue';
import Store from 'store';

import SkyReveal from './SkyReveal';
import SkyRevealTrigger from './SkyRevealTrigger';
import SkyRevealStore from './store';

Store.registerModule('SkyReveal', SkyRevealStore);

// Main component
Vue.component('SkyReveal', SkyReveal);

// Sub component(s)
Vue.component('SkyRevealTrigger', SkyRevealTrigger);

export default SkyReveal;



// WEBPACK FOOTER //
// ./scripts/sky-reveal/index.js